module.exports = __webpack_public_path__ + "img/ilus03.1cdd273e.gif";